import { Outlet, Link } from "react-router-dom";
import Logo from "../../components/ui/Logo.jsx";
import { useAuth } from "../../lib/useAuth";
import { useClientProjects } from "../../lib/useClientProjects";
import styles from "./PortalLayout.module.css";

export default function PortalLayout() {
  const { user, client, signOut } = useAuth();
  const name = client?.name || user?.displayName || user?.email;
  const firstName = user?.displayName ? user.displayName.split(' ')[0] : name;
  
  const email = client?.email || user?.email || "";
  const { items } = useClientProjects(email);
  const clientLogo = items?.[0]?.clientLogo;

  return (
    <div className={styles.shell}>
      <header className={styles.head}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {clientLogo && (
              <>
                <img src={clientLogo} alt="Client Logo" style={{ height: '36px', maxWidth: '140px', objectFit: 'contain' }} />
                <span style={{ margin: '0 1.25rem', color: 'var(--color-line)', fontSize: '1.5rem', fontWeight: '300' }}>|</span>
              </>
            )}
            <Link to="/" className={styles.brand} aria-label="Aya Technologies">
              <Logo size={120} />
            </Link>
          </div>
          <Link to="/" className={styles.backHome} style={{ margin: 0 }} title="Inicio">
            <svg className={styles.iconOnlyMobile} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            <span className={styles.hideMobile}>← Inicio</span>
          </Link>
        </div>

        <div className={styles.headRight}>
          <span className={styles.who} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexDirection: 'row' }}>
            <span className={styles.whoName}>{firstName}</span>
            {user?.photoURL && (
              <img 
                src={user.photoURL} 
                alt="Perfil" 
                style={{ width: '38px', height: '38px', borderRadius: '50%', objectFit: 'cover', border: '1px solid var(--color-line)' }} 
              />
            )}
          </span>
          <button onClick={signOut} className={styles.signout} title="Cerrar sesión">
            <svg className={styles.iconOnlyMobile} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span className={styles.hideMobile}>Cerrar sesión</span>
          </button>
        </div>
      </header>

      <main className={styles.view}>
        <Outlet />
      </main>
    </div>
  );
}
